import { sendRegisterEmail } from "../../lib/email/send/sendRegisterEmail"
import { notification } from "antd"
import { FormikHelpers } from "formik"
import React from "react"
import axios, { AxiosResponse } from "axios"
import { event, purchaseEvent } from "../../lib/ga"
import { RegisterStudentCourse } from "./types"
import { InsertCourseRegistration, OutputCourseRegistration } from "../../lib/supabase/insertCourseRegistration"
import { CheckCourseCapacity } from "../../lib/supabase/checkCourseCapacity"
import { addSubscriberByEmail } from "../../lib/ecomail/addSubscriberByEmail"
import { getEmailRecipients } from "../../lib/supabase/registrations/getEmailRecipients"
import { MappedCourse } from "../../lib/prismic/MappedCourse"
import { getLocalStorage } from "../../lib/gaTracking/storageHelper"
import { hashEmail } from "../../lib/hashEmail"
import { removeSubscriberByEmail } from "../../lib/ecomail/removeSubscriberByEmail"
import { clearUtmParamsFromStorage, UtmParams } from "../../lib/utmParams"
import { InvoiceCreateRequest } from "../../pages/api/invoice/createAndGetPdf"

export const onSubmitHandler = async (
  initialValues: RegisterStudentCourse,
  values: RegisterStudentCourse,
  formikHelpers: FormikHelpers<RegisterStudentCourse>,
  course: MappedCourse,
  setFormCompleteSend: React.Dispatch<React.SetStateAction<OutputCourseRegistration | null>>,
  resetAntdFormFields: () => void,
  utmParams?: UtmParams
): Promise<OutputCourseRegistration | undefined> => {
  try {
    const capacity = await axios
      .post("/api/course-registration/check-course-capacity", {
        courseSlug: course.slug,
        capacity: course.capacity
      })
      .catch((e) => console.error(e))
      .then((res: AxiosResponse<CheckCourseCapacity>) => res.data)

    if (capacity.all.isFull) {
      console.error({
        message: "Registrace",
        description: "Registrace neproběhla. Omlouváme se, byla naplněna kapacita kurzu. Kontaktujte lektora. Děkujeme za pochopení."
      })

      notification.error({
        message: "Registrace",
        description: "Registrace neproběhla. Omlouváme se, byla naplněna kapacita kurzu. Kontaktujte lektora. Děkujeme za pochopení.",
        duration: 0
      })
      return
    }

    const registration = await axios
      .post("/api/course-registration", {
        apiKey: process.env.NEXT_PUBLIC_API_KEY,
        registration: values,
        course: {
          slug: course.slug,
          seedNumber: course.seedNumber,
          name: course.name,
          equipmentPrice: course.equipmentPrice,
          price: course.price
        },
        utmParams
      } as InsertCourseRegistration)
      .catch((e: any) => {
        if (e?.response?.data?.name === "DuplicateError") {
          if (values.withGiftVoucher) {
            console.error({
              message: "Registrace",
              description: `Registrace neproběhla. Děkujeme`
            })
            notification.error({
              message: "Registrace",
              description: `Registrace neproběhla. Děkujeme`,
              duration: 0
            })
          } else {
            console.error({
              message: "Registrace",
              description: `Registrace již existuje. Student s emailovou adresou (${values.student.email}) je již na tento kurz přihlášen. Zkontrolujte si emailovou schránku včetně nevyžádané složky. Děkujeme`
            })
            notification.error({
              message: "Registrace",
              description: `Registrace již existuje. Student s emailovou adresou (${values.student.email}) je již na tento kurz přihlášen. Zkontrolujte si emailovou schránku včetně nevyžádané složky. Děkujeme`,
              duration: 0
            })
          }
          return
        }

        console.error({
          message: "Registrace",
          description: `Registrace neproběhla úspěšně. Zkuste to později. Pokud obtíže přetrvají, kontaktujte nás. Děkujeme za pochopení. ${JSON.stringify(e)}`
        })
        notification.error({
          message: "Registrace",
          description: `Registrace neproběhla úspěšně. Zkuste to později. Pokud obtíže přetrvají, kontaktujte nás. Děkujeme za pochopení. ${JSON.stringify(e)}`,
          duration: 0
        })
        return
      })
      .then((res: AxiosResponse<OutputCourseRegistration>) => res.data)

    // setFormCompleteSend(registration)

    if (registration.payment?.amount?.value > 0) {
      const invoiceCreateRequest: InvoiceCreateRequest = {
        documentType: "proforma",
        variableSymbol: registration.payment.variableNumber,
        courseName: course.name,
        price: registration.payment.amount.value,
        customerData: {
          email: values.studentContact?.email || values.student.email,
          city: values.invoice.city,
          name:
            values.studentContact?.firstname?.length > 0 && values.studentContact?.lastname?.length > 0
              ? `${values.studentContact.firstname} ${values.studentContact.lastname}`
              : `${values.student.firstname} ${values.student.lastname}`,
          country: values.invoice.country,
          street: values.invoice.street,
          zip: values.invoice.zip,
          registration_no: values.invoice.registration_no,
          vat_no: values.invoice.vat_no
        }
      }
      await axios.post("/api/course-registration/createCustomerAndInvoice", {
        ...invoiceCreateRequest,
        apiKey: process.env.NEXT_PUBLIC_API_KEY
      })
    }

    const emails = getEmailRecipients(values.withGiftVoucher, values.studentContact?.email, values.student.email)

    const sendRegisterEmailRes = await sendRegisterEmail(values, course, registration.payment, emails, registration.registration.id, (err) => {
      console.error({
        message: "Registrace",
        description: `Registrace neproběhla úspěšně. Zkuste to později. Pokud obtíže přetrvají, kontaktujte nás. Děkujeme za pochopení. ${JSON.stringify(err)}`
      })
      notification.error({
        message: "Registrace",
        description: `Registrace neproběhla úspěšně. Zkuste to později. Pokud obtíže přetrvají, kontaktujte nás. Děkujeme za pochopení. ${JSON.stringify(err)}`,
        duration: 0
      })
      return
    })

    if (sendRegisterEmailRes?.status !== 200) {
      console.error({
        message: "Registrace",
        description: `Registrace neproběhla úspěšně. Zkuste to později. Pokud obtíže přetrvají, kontaktujte nás. Děkujeme za pochopení. ${JSON.stringify(
          sendRegisterEmailRes
        )}`
      })
      notification.error({
        message: "Registrace",
        description: `Registrace neproběhla úspěšně. Zkuste to později. Pokud obtíže přetrvají, kontaktujte nás. Děkujeme za pochopení. ${JSON.stringify(
          sendRegisterEmailRes
        )}`,
        duration: 0
      })
      return
    }

    if (values.newsletterAgreement) {
      await Promise.all(
        emails.map(
          async (email) =>
            await addSubscriberByEmail(email, ["krouzky", "registrace", course.slug, course.ageGroup, course.type]).catch((err) => console.error(err))
        )
      )
    }

    event({
      action: "register",
      category: "course",
      label: course.name,
      value: registration.payment.amount.value
    })

    purchaseEvent({
      items: [
        {
          affiliation: "Website",
          currency: "CZK",
          item_brand: "VzdelaniBudoucnosti z.s.",
          item_category: course.courseVariant,
          item_id: course.id,
          item_name: course.name,
          item_variant: `${course.ageGroup}/${course.type}`,
          price: registration.payment.amount.value,
          quantity: 1
        }
      ],
      affiliation: "Website",
      currency: "CZK",
      shipping: 0,
      tax: 0,
      transaction_id: registration.payment.variableNumber,
      value: registration.payment.amount.value
    })

    await Promise.all(emails.map(async (email) => await removeSubscriberByEmail(email, 7)))
    //https://vzdelanibudoucnosti.ecomailapp.cz/contacts/7/

    const storedCookieConsent = getLocalStorage("cookie_consent", null)

    // sklik conversion code for form
    // @ts-ignore
    if (window?.rc?.conversionHit) {
      // @ts-ignore
      window.rc.conversionHit({
        id: 100180483,
        value: registration?.payment?.amount?.value ?? null,
        consent: storedCookieConsent ? 1 : 0,
        eid: hashEmail(registration.legalRepresentative.email || registration.student.email)
      })
    }

    setFormCompleteSend(registration)

    formikHelpers.resetForm({ values: initialValues })
    resetAntdFormFields()

    clearUtmParamsFromStorage()

    return registration
  } catch (e) {
    console.error(`Error during registration: ${JSON.stringify(e)}`)
  }
}
